var styleDataHash = "8421b3ac";
const injectCss = () => {
  var css = `.b5ZXT,.rNslZ{height:386px;overflow:auto}[dir] .b5ZXT,[dir] .rNslZ{margin-top:20px}[dir=ltr] .b5ZXT,[dir=ltr] .rNslZ{margin-right:-16px;padding-right:16px}[dir=rtl] .b5ZXT,[dir=rtl] .rNslZ{margin-left:-16px;padding-left:16px}.b5ZXT.M1WGq,.rNslZ.M1WGq{height:calc(100vh - 190px)}.X0VCF{display:flex;flex-direction:column}[dir=ltr] .inhXC{float:right;text-align:right}[dir=rtl] .inhXC{float:left;text-align:left}[dir] .fch38{cursor:pointer}.fch38:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}._7iweF{align-items:center;display:flex;height:100%;justify-content:center;width:100%}[dir] ._7iweF{margin-top:50px}.boVer{height:100%;width:100%}.b5ZXT,.boVer{align-items:center;display:flex;justify-content:center}.b5ZXT{max-width:100%}.lOd2H{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_selector_default = {
  "giphy_selector_infinite_scroll_container": "rNslZ",
  "giphySelectorErrorContainer": "b5ZXT",
  "mobile": "M1WGq",
  "giphy_selector_infinite_scroll": "X0VCF",
  "giphy_selector_powerdByGiphy": "inhXC",
  "giphy_selector_gif_img_container": "fch38",
  "giphy_selector_spinner_load_more": "_7iweF",
  "giphy_selector_spinner_empty_modal": "boVer",
  "searchInput": "lOd2H"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
